module.exports = __webpack_public_path__ + "files/2493e0138b633066ee3afcef5196c852.png";